import type { ComponentChildren, JSX } from 'preact'

export function Dot({
    index,
    children,
}: {
    index: number
    children: ComponentChildren
}) {
    return (
        <button
            type='button'
            data-dot={index}
            aria-label={`go to slider item ${index}`}
            class='focus:outline-none group'
        >
            {children}
        </button>
    )
}

export function DotGroup({ children, ...props }: JSX.IntrinsicElements['div']) {
    return (
        <div data-dot-group {...props}>
            {children}
        </div>
    )
}

function Slider(props: JSX.IntrinsicElements['ul']) {
    return <ul data-slider {...props} />
}

export function Item({ index, ...props }: JSX.IntrinsicElements['li'] & { index: number }) {
    return <li data-slider-item={index} {...props} />
}

export function NextButton(props: JSX.IntrinsicElements['button']) {
    return <button type='button' data-slide='next' aria-label='Next item' {...props} />
}

export function PrevButton(props: JSX.IntrinsicElements['button']) {
    return <button type='button' data-slide='prev' aria-label='Previous item' {...props} />
}

Slider.Dot = Dot
Slider.Item = Item
Slider.DotGroup = DotGroup
Slider.NextButton = NextButton
Slider.PrevButton = PrevButton

export default Slider
